import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { CallAPIPromise } from "../billing/common";



export function AddAppDialog({ open, onOpenChange, onAdd }) {
  const [formData, setFormData] = useState({
    name: "",
    icon: "",
    iosVersion: "1.0.0",
    iosBuildNumber: "1",
    androidVersion: "1.0.0",
    androidBuildNumber: "1",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const newApp = {
      id: Date.now().toString(),
      name: formData.name,
      icon: formData.icon || formData.name.charAt(0).toUpperCase(),
      iosVersion: formData.iosVersion,
      iosBuildNumber: formData.iosBuildNumber,
      iosStatus: "development",
      androidVersion: formData.androidVersion,
      androidBuildNumber: formData.androidBuildNumber,
      androidStatus: "development",
      lastUpdated: new Date().toISOString(),
    };
 CallAPIPromise("/api/crossMobileAppVersion/addVersion",newApp).then((res)=>{
  console.log(res)
 })
    onAdd(newApp);
    setFormData({
      name: "",
      icon: "",
      iosVersion: "1.0.0",
      iosBuildNumber: "1",
      androidVersion: "1.0.0",
      androidBuildNumber: "1",
    });
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <div>
          <DialogTitle>Add New App</DialogTitle>
          <DialogDescription>
            Create a new app to track versions across iOS and Android platforms.
          </DialogDescription>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <Label htmlFor="name">App Name</Label>
              <Input
                id="name"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                placeholder="My Awesome App"
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="icon">Icon (emoji or single character)</Label>
              <Input
                id="icon"
                value={formData.icon}
                onChange={(e) => setFormData({ ...formData, icon: e.target.value })}
                placeholder="📱"
                maxLength={2}
              />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label htmlFor="iosVersion">iOS Version</Label>
                <Input
                  id="iosVersion"
                  value={formData.iosVersion}
                  onChange={(e) => setFormData({ ...formData, iosVersion: e.target.value })}
                  placeholder="1.0.0"
                  required
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="iosBuild">iOS Build</Label>
                <Input
                  id="iosBuild"
                  value={formData.iosBuildNumber}
                  onChange={(e) => setFormData({ ...formData, iosBuildNumber: e.target.value })}
                  placeholder="1"
                  required
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label htmlFor="androidVersion">Android Version</Label>
                <Input
                  id="androidVersion"
                  value={formData.androidVersion}
                  onChange={(e) => setFormData({ ...formData, androidVersion: e.target.value })}
                  placeholder="1.0.0"
                  required
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="androidBuild">Android Build</Label>
                <Input
                  id="androidBuild"
                  value={formData.androidBuildNumber}
                  onChange={(e) => setFormData({ ...formData, androidBuildNumber: e.target.value })}
                  placeholder="1"
                  required
                />
              </div>
            </div>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button type="submit">Add App</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
